/* eslint-disable */
export default {
  loginButton: 'Aanmelden',
  signupButton: 'Nieuwe gebruiker? Registreren',
  version: 'Versie',
} as const;

// @key: @#@"loginButton"@#@ @source: @#@"Sign In"@#@
// @key: @#@"signupButton"@#@ @source: @#@"New user? Sign Up"@#@
// @key: @#@"version"@#@ @source: @#@"Version"@#@
